import {useEffect, useState} from "react";
import {worktimetracking} from "../request/worktimetracking";
import {checkLogin} from "../../../../@WUM/templates/default/Auth/service/AuthService";
import {error} from "../../../../@WUM/core/component/const/error.services";
import {
    NotificationSettingsInterface,
    SettingsInterface,
    UserOptions, VacationDashboardWidgetInterface
} from "../request/settingsworktimetrackingInterface";

export const ResponseSettings = (
    userId?: string | undefined,
): boolean | SettingsInterface | undefined => {
    const [posts, setPosts] = useState<SettingsInterface>()
    const [isError, setIsError] = useState<boolean>(false)
    useEffect(() => {
        ;(async () => {
            await worktimetracking
                .settings(userId)
                .then((data) => {
                    checkLogin(data)
                    if (typeof data.workingDays === "string") {
                        try {
                            data.workingDays = JSON.parse(data.workingDays);
                        } catch {
                            console.warn("Invalid workingDays format:", data.workingDays);
                        }
                    }
                    setPosts(data)
                })
                .catch((err) => {
                    error(err)
                    setIsError(true)
                })
        })()

    }, [])

    return isError ? isError : posts
}

export const AllUser = (): boolean | UserOptions | undefined => {
    const [posts, setPosts] = useState<UserOptions>()
    const [isError, setIsError] = useState<boolean>(false)
    useEffect(() => {
        ;(async () => {
            await worktimetracking
                .employees()
                .then((data) => {
                    checkLogin(data)
                    setPosts(data)
                })
                .catch((err) => {
                    error(err)
                    setIsError(true)
                })
        })()

    }, [])

    return isError ? isError : posts
}

export const ResponseAutoClockOutSettings = (userId?: string | undefined): boolean | SettingsInterface | undefined => {
    const [posts, setPosts] = useState<SettingsInterface>()
    const [isError, setIsError] = useState<boolean>(false)
    useEffect(() => {
        ;(async () => {
            await worktimetracking
                .autoclock(userId)
                .then((data) => {
                    checkLogin(data)
                    setPosts(data)
                })
                .catch((err) => {
                    error(err)
                    setIsError(true)
                })
        })()

    }, [])

    return isError ? isError : posts
}

export const ResponseAutoBreakSettings = (userId?: string | undefined): boolean | SettingsInterface | undefined => {
    const [posts, setPosts] = useState<SettingsInterface>()
    const [isError, setIsError] = useState<boolean>(false)
    useEffect(() => {
        ;(async () => {
            await worktimetracking
                .autobreak(userId)
                .then((data) => {
                    checkLogin(data)
                    setPosts(data)
                })
                .catch((err) => {
                    error(err)
                    setIsError(true)
                })
        })()

    }, [])

    return isError ? isError : posts
}

export const ResponseNotificationSettings = (): boolean | NotificationSettingsInterface | undefined => {
    const [posts, setPosts] = useState<NotificationSettingsInterface>()
    const [isError, setIsError] = useState<boolean>(false)
    useEffect(() => {
        ;(async () => {
            await worktimetracking
                .notificationSettings()
                .then((data) => {
                    checkLogin(data)
                    setPosts(data)
                })
                .catch((err) => {
                    error(err)
                    setIsError(true)
                })
        })()

    }, [])

    return isError ? isError : posts
}

export const ResponseHolidayDashboard = (userId: string): boolean | VacationDashboardWidgetInterface | undefined => {
    const [posts, setPosts] = useState<VacationDashboardWidgetInterface>()
    const [isError, setIsError] = useState<boolean>(false)
    useEffect(() => {
        ;(async () => {
            await worktimetracking
                .holidayDetailDashboard(userId)
                .then((data) => {
                    checkLogin(data)
                    setPosts(data)
                })
                .catch((err) => {
                    error(err)
                    setIsError(true)
                })
        })()

    }, [userId])

    return isError ? isError : posts
}